import { render, staticRenderFns } from "./ModalNuovaTratta.vue?vue&type=template&id=4a4e6d40&"
import script from "./ModalNuovaTratta.vue?vue&type=script&lang=js&"
export * from "./ModalNuovaTratta.vue?vue&type=script&lang=js&"
import style0 from "./ModalNuovaTratta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalNuovaTratta.vue
// module id = 842
// module chunks = 0